// src/components/KurumList.js
import React from "react";
import {
  List,
  Datagrid,
  TextField,
  BooleanField,
  DateField,
} from "react-admin";
import { useNavigate } from "react-router-dom";

const KurumList = (props) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/", { replace: true });
    window.location.reload(); // güvenli çıkış için sayfa yenile
  };

  return (
    <div className="p-6">
      {/* Üst Başlık ve Logout */}
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-bold text-gray-200">📋 Kurumlar Listesi</h1>
        <button
          onClick={handleLogout}
          className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg shadow"
        >
          Çıkış Yap
        </button>
      </div>

      {/* react-admin Liste */}
      <List {...props} title="">
        <Datagrid rowClick="edit">
          <TextField source="id" label="ID" />
          <TextField source="ad" label="Ad" />
          <TextField source="il" label="İl" />
          <TextField source="ilce" label="İlçe" />
          <BooleanField source="aktif" label="Aktif mi?" />
          <DateField source="olusturma_tarihi" label="Oluşturma Tarihi" />
        </Datagrid>
      </List>
    </div>
  );
};

export default KurumList;
